import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { permitKeys } from '@core/react-query/features/permits/permit'
import { permitsKeys } from '@core/react-query/features/permits'
import { useRealTimeSubscription } from '@core/providers/useRealTimeSubscription'
import { PusherOptions } from '@core/providers/usePusher'

export const useRealTimePermit = (
  permitId: number,
  options?: PusherOptions,
) => {
  const { channel, bindEventHandler } = useRealTimeSubscription(
    `private-permit.${permitId}`,
    options,
  )
  const queryClient = useQueryClient()

  useEffect(() => {
    bindEventHandler('permit.updated', (data) => {
      const queryKey = permitKeys.byId({ permitId }).queryKey
      queryClient.invalidateQueries(queryKey)

      // Invalidate permit list queries so the list view reflects the updated status (This filters out the mine permits as well)
      queryClient.invalidateQueries({ queryKey: permitsKeys.allPermits._def })
    })
  }, [channel])
}
